var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['header']},[_vm._t("icon"),_vm._v(" "),_c('h3',{class:[
            _vm.$style['header__title'],
            'sw-title',
            'sw-title_m0' ]},[_vm._t("default")],2),_vm._v(" "),_c('div',{class:_vm.$style['header__close'],on:{"click":function($event){return _vm.$emit('close')}}},[_c('SwIconButton',[_c('SvgIconCross')],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }